import { Link } from "react-router-dom";

export const PLACEMENT_LABELS = {
  home_top: "Home top",
  home: "Home",
  browse: "Browse",
  browse_sidebar: "Browse sidebar",
  listing: "Listing",
};

// Renders an ad-placement name as a link to the public placements explainer page.
// Use `newTab` inside the staff/admin area so it doesn't navigate away from the panel.
export const PlacementLink = ({ placement, label, className = "", newTab = false }) => {
  const text = label || PLACEMENT_LABELS[placement] || placement;
  const to = `/advertising/placements#${placement}`;
  const cls = `underline decoration-dotted underline-offset-2 hover:text-[#F5551E] transition-colors ${className}`;
  if (newTab) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" title="See where this ad appears"
         className={cls} data-testid={`placement-link-${placement}`}>{text}</a>
    );
  }
  return (
    <Link to={to} title="See where this ad appears" className={cls} data-testid={`placement-link-${placement}`}>{text}</Link>
  );
};
